<template>
    <div class="col-12 col-md-3 col-lg-2 mb-4 cursor-pointer">
      <div class="card p-3 h-100"
        :style="{
          backgroundColor: $getCssVariable('--bs-primary').trim()+ '10',
          border: (model == office.id) ? '1px solid ' + $getCssVariable('--bs-primary').trim() : null
        }"
        @click.prevent="handleSelection(office.id, office.name)">
        <div class="d-flex flex-stack">
          <div class="symbol  symbol-40px me-4">
            <div class="symbol-label fs-2 py-10 px-8 " :style="{backgroundColor: withCount ? '#fff' : $getCssVariable('--bs-primary').trim()+ '00'}" >
              <span  v-if="withCount" class="text-danger">{{office[attr] || 0}}</span>
            </div>
          </div>
          <div class="d-flex align-items-center flex-row-fluid flex-wrap">
            <div class="flex-grow-1 me-2">
              <a class="text-primary fs-6 fw-bolder">
                {{office.name}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    
  <script setup> 
  import {onMounted} from "vue";
  import {useRoute, useRouter} from "vue-router";
  
  const router = useRouter()
  const route = useRoute()
  const model = defineModel()
  
  
  const props = defineProps({
      office: {type: Object, default: () => ({})},
      withCount: {type: Boolean, default: true},
      attr: {type: String, default: 'expenses_count'}
  })
  
  const handleSelection = (id) => {
    model.value = id
    router.replace({ name: route.name, params: { ...route.params, id: props.office.id } })
  }
  
  onMounted(() => {
  })
  
  </script>
  <style>
  </style>